import React from "react";
import { getI18NMessage } from "./../../../i18n/I18N";
import logoImg from "./../../../../assets/images/logos/nimbleworklogo.svg";
import googleLogoImg from "./../../../../assets/images/logos/googlelogo.png";
import appleLogoImg from "./../../../../assets/images/logos/applelogo.png";
import CredLogin from "./CredLogin";
import LoginFooter from "./LoginFooter";
import UI_CONSTANTS from "../../app/constants/UIConstants";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import { ReactSwitchSite } from "@nimblework-components/react-switch-site";

class LoginPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isForgotPassword: false,
      accounts: []
    };

    this.sidePanelRef = React.createRef();
  }

  componentDidMount() {
    this.props.initLoginComp(this.props.appUrlHash);
  }

  render() {
    if (!this.props.loginData) {
      return false;
    }

    const logo =
      this.props.loginData.logo || `${window.appCdnPath || ""}${logoImg}`;
    const { leftpanel, rightpanel, footer, notification, nopageinfo } =
      this.props.loginData;
    const { appUrlHash } = this.props;
    const isForgotPassword = appUrlHash?.includes(
      UI_CONSTANTS.FORGOT_PW_URL_HASH
    );
    const isResetPassword = appUrlHash?.includes(
      UI_CONSTANTS.RESET_PW_URL_HASH
    );
    const showFpEmailInfo = appUrlHash?.includes(
      UI_CONSTANTS.FORGOT_PW_EMAIL_URL_HASH
    );
    const showResetPwdInfo = appUrlHash?.includes(
      UI_CONSTANTS.RESET_PW_MSG_URL_HASH
    );
    const showMultipleAccountPage = appUrlHash?.includes(
      UI_CONSTANTS.MULTIPLE_ACCOUNT
    );

    let headerKey = "login";

    if (isForgotPassword) {
      headerKey = "forgotyourpassword";
    } else if (showMultipleAccountPage) {
      headerKey = "selectTheSite";
    }

    const bodyWidth =
      typeof document === "object" ? document.body.clientWidth : 1000;

    return (
      <div className="login-page">
        <div className="lg-left-panel">
          <div className="lg-header">
            <img src={logo} className="logo" alt={getI18NMessage("logalt")} />
            {!isResetPassword && (
              <span
                className={`header-txt ${showMultipleAccountPage ? "header-with-info" : ""}`}
              >
                {getI18NMessage(headerKey)}
              </span>
            )}
            {showMultipleAccountPage && (
              <span className="header-text-info">
                {getI18NMessage("headerTextInfo")}
              </span>
            )}
          </div>
          {notification && (
            <div className="lg-info-cnt">
              <div className="lg-info-indicator"></div>
              <div
                className="lg-info-text"
                dangerouslySetInnerHTML={{ __html: notification }}
              />
            </div>
          )}
          {showFpEmailInfo && (
            <div className="lg-info-cnt">
              <div className="lg-info-indicator"></div>
              <div className="icon-success lg-info-icon"></div>
              <div className="lg-info-text">
                {getI18NMessage("fpemailinfo")}
              </div>
            </div>
          )}
          {showResetPwdInfo && (
            <div className="lg-info-cnt">
              <div className="lg-info-indicator"></div>
              <div className="icon-success lg-info-icon"></div>
              <div className="lg-info-text">
                {getI18NMessage("resetPwdInfo")}
              </div>
            </div>
          )}
          <div
            className={`lg-body ${isForgotPassword || isResetPassword ? "lg-body-fp" : ""}`}
          >
            {!isForgotPassword &&
              !isResetPassword &&
              !showMultipleAccountPage &&
              leftpanel.map(leftPanelComp =>
                this.getLeftPanelComp(
                  leftPanelComp.id,
                  {
                    config: leftPanelComp
                  },
                  nopageinfo
                )
              )}
            {isForgotPassword && !showMultipleAccountPage && (
              <ForgotPassword
                appUrlHash={this.props.appUrlHash}
                captcha={this.props.loginData.captcha}
              />
            )}
            {isResetPassword && !showMultipleAccountPage && (
              <ResetPassword
                appUrlHash={this.props.appUrlHash}
                validResetLink={this.props.validResetLink}
              />
            )}
            {showMultipleAccountPage && (
              <ReactSwitchSite
                getI18NMessage={getI18NMessage}
                accounts={this.state.accounts}
                connectURL="/rest/v1/auth/login"
                username={this.state.username}
                password={this.state.password}
              />
            )}
          </div>
          {!showMultipleAccountPage && footer?.length && (
            <LoginFooter config={footer} />
          )}
        </div>
        {!showMultipleAccountPage &&
          rightpanel &&
          rightpanel.length &&
          bodyWidth >= 992 && (
            <div className="lg-right-panel" ref={this.sidePanelRef}>
              {rightpanel
                .filter(rightPanelConfig => rightPanelConfig.enabled)
                .map(rightPanelConfig =>
                  this.getRightPanelComp(rightPanelConfig)
                )}
            </div>
          )}
      </div>
    );
  }

  getLeftPanelComp(compId, props, nopageinfo) {
    if (compId === "credlogin") {
      return (
        <CredLogin
          {...props}
          key={compId}
          appUrlHash={this.props.appUrlHash}
          captcha={this.props.loginData.captcha}
          parentStateUpdate={stateData => {
            this.setState(stateData);
          }}
        />
      );
    } else if (compId === "idphint" && !nopageinfo) {
      const idpImages = {
        google: googleLogoImg,
        apple: appleLogoImg
      };

      return (
        <React.Fragment key="idp-fragement">
          {props.config.hints && props.config.hints.length > 0 && (
            <div className="lg-idp-seprator">
              <div className="lg-idp-or-line"></div>
              <div className="lg-idp-or-txt">{getI18NMessage("or")}</div>
            </div>
          )}
          {props.config.hints && props.config.hints.length > 0 && (
            <div className="lg-idp-hints-list-cnt">
              {props.config.hints.map(idpHint => (
                <a
                  key={idpHint.id}
                  className="lg-idp-hint-cnt"
                  href={`/rest/v1/auth/brokers/oidc/login/${idpHint.id}`}
                >
                  <div className="ipd-hint-logo">
                    <img
                      src={idpImages[idpHint.id]}
                      alt={getI18NMessage(idpHint.id)}
                    />
                  </div>
                  <div className="ipd-hint-text">
                    {getI18NMessage(idpHint.id)}
                  </div>
                </a>
              ))}
            </div>
          )}
        </React.Fragment>
      );
    } else {
      return false;
    }
  }

  getRightPanelComp(config) {
    if (config.id === UI_CONSTANTS.TWITTER_WIDGET) {
      return (
        <a
          className="twitter-timeline"
          href={config.url}
          key={config.id}
          data-width="308"
        >
          {getI18NMessage("tweetsbyNimbleWorkInc")}
        </a>
      );
    } else if (config.id === UI_CONSTANTS.FACEBOOK_WIDGET) {
      return (
        <div
          className="fb-page"
          data-href={config.url}
          data-tabs="timeline"
          data-width="313"
          data-height={window.innerHeight - 20}
          data-small-header="true"
          data-adapt-container-width="true"
          data-hide-cover="true"
          data-show-facepile="true"
          key={config.id}
        >
          <blockquote cite={config.url} className="fb-xfbml-parse-ignore">
            <a href={config.url}>{getI18NMessage("nimbleworkInc")}</a>
          </blockquote>
        </div>
      );
    }
  }
}

export default LoginPage;
